import { Bar, Doughnut } from "react-chartjs-2"

import { ApiTypes } from "types"

import { chartColors, commonChartOptions } from "./chartConfig"
import { ChartCard, Legend, type LegendItem, Section, type SelectOption, SelectPill } from "./components"
import { type EnterpriseChartData, formatNumber, selectOptions } from "./dashboardData"

import styles from "./index.module.scss"

type Props = {
  contractorOptions: SelectOption[]
  isContractorsLoading: boolean
  orderChartOption: string
  contractorId: string
  orderStatuses: ApiTypes.Res.EnterpriseDashboardOrderStatusesWidget
  orderStatusChartData: EnterpriseChartData<"doughnut">
  orderStatusLegendItems: LegendItem[]
  orderedByTypeChartData: EnterpriseChartData<"bar">
  onOrderChartOptionChange: (option: string) => void
  onContractorChange: (option: string) => void
}

export const OrdersWidget = ({
  contractorOptions,
  isContractorsLoading,
  orderChartOption,
  contractorId,
  orderStatuses,
  orderStatusChartData,
  orderStatusLegendItems,
  orderedByTypeChartData,
  onOrderChartOptionChange,
  onContractorChange,
}: Props) => (
  <Section
    title="Orders"
    controls={
      <>
        <SelectPill options={selectOptions.sevenDays} value={orderChartOption} onChange={onOrderChartOptionChange} />
        <SelectPill
          options={contractorOptions}
          value={contractorId}
          disabled={isContractorsLoading}
          onChange={onContractorChange}
        />
      </>
    }
  >
    <ChartCard title="Statuses" className={styles.statusCard}>
      <div className={styles.doughnutLayout}>
        <div className={styles.doughnutWrap}>
          <Doughnut
            data={orderStatusChartData}
            options={{
              maintainAspectRatio: false,
              plugins: { legend: { display: false }, tooltip: commonChartOptions.plugins.tooltip },
              cutout: "68%",
            }}
          />
          <div className={styles.doughnutCenter}>
            <span>Active Orders</span>
            <strong>{formatNumber(orderStatuses.active_orders)}</strong>
          </div>
        </div>
        <Legend items={orderStatusLegendItems} />
      </div>
    </ChartCard>
    <ChartCard title="Devices Ordered by Type Over Time">
      <div className={styles.largeChart}>
        <Bar data={orderedByTypeChartData} options={commonChartOptions} />
      </div>
      <Legend
        items={[
          { label: "Nuve Thermostats", color: chartColors.thermostats },
          { label: "Wire Adapters (CWA)", color: chartColors.cwa },
          { label: "THS", color: chartColors.ths },
          { label: "WLS", color: chartColors.wls },
        ]}
      />
    </ChartCard>
  </Section>
)
